import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../config";
import { showToast } from "../../../utils/toast";
import CategoryModal from "../Modals/CategoryModal";


export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/inventory/get-categories.php`
      );

      if (res.data.success) {
        setCategories(res.data.data);
      }
    } catch (error) {
      showToast("error", "Failed to load categories");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;

    try {
      const res = await axios.delete(
        `${config.apiBaseUrl}/inventory/delete-category.php`,
        { data: { category_id: id } }
      );

      if (res.data.success) {
        showToast("success", res.data.message);
        fetchCategories();
      }
    } catch (error) {
      showToast("error", "Delete failed");
    }
  };

  return (
    <div className="container-fluid">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Inventory Categories</h5>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            setEditData(null);
            setShowModal(true);
          }}
        >
          + Add Category
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Category Name</th>
                <th>Description</th>
                <th width="120">Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((cat, index) => (
                  <tr key={cat.category_id}>
                    <td>{index + 1}</td>
                    <td>{cat.category_name}</td>
                    <td>{cat.description || "-"}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => {
                          setEditData(cat);
                          setShowModal(true);
                        }}
                      >
                        Edit
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.category_id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No categories found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <CategoryModal
          show={showModal}
          onClose={() => setShowModal(false)}
          refresh={fetchCategories}
          editData={editData}
        />
      )}

    </div>
  );
}